import { FormDataAccountType } from ".";

export const emptyValues: FormDataAccountType = {
  country: "US",
  type: "Individual",
  representativeConfirmation: false,
  isUsPerson: false
};
